import personasJson from '../../data/personas.json' with { type: 'json' };

export type PersonaSlug =
  | 'principal-ai-engineer'
  | 'eng-manager'
  | 'cto'
  | 'product-manager'
  | 'sdet-qa'
  | 'research-engineer'
  | 'data-engineer'
  | 'backend-engineer'
  | 'frontend-engineer';

export type Persona = {
  slug: PersonaSlug;
  name: string;
  shortName: string;
  icon: string;
  color: { light: string; dark: string };
  proseCodeRatio: string;
  tone: string;
  audience: string;
  jtbd: string[];
};

export const personas = personasJson as Persona[];

export const personaBySlug: Record<PersonaSlug, Persona> = Object.fromEntries(
  personas.map((p) => [p.slug, p]),
) as Record<PersonaSlug, Persona>;

export function isPersonaSlug(value: string): value is PersonaSlug {
  return value in personaBySlug;
}
